import { render, staticRenderFns } from "./PopClientsList.vue?vue&type=template&id=a8d4b802&scoped=true"
import script from "./PopClientsList.vue?vue&type=script&lang=js"
export * from "./PopClientsList.vue?vue&type=script&lang=js"
import style0 from "./PopClientsList.vue?vue&type=style&index=0&id=a8d4b802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d4b802",
  null
  
)

export default component.exports